import { ChangeEvent } from 'react';

interface ITableDropdownOption {
  label: string | number;
  value: string | number;
}

interface ITableDropdown {
  data: ITableDropdownOption[];
  onChange: (e: ChangeEvent<HTMLSelectElement>) => void;
  selectedValue: string | number;
}

/**
 * It renders a dropdown for table pagination.
 */
export function TableDropdown({
  onChange,
  data,
  selectedValue,
}: Readonly<ITableDropdown>) {
  return (
    <select
      className="min-w-14 border-0 bg-transparent px-2 py-0 text-xs"
      name="itemsPerPage"
      onChange={onChange}
      value={selectedValue}
    >
      {data.map(({ value, label }) => (
        <option key={value} value={value}>
          {label}
        </option>
      ))}
    </select>
  );
}
